import {
  AddMember,
  AddGroup,
  CheckDomainVerificationStatus,
  CreateOrg,
  GetMyOrg,
  ResetPassword,
  SuspendMember,
  EmailPassword,
  DkimAttributes,
} from "@zickko/shared";
import { httpsCallable } from "firebase/functions";
import { firebaseFunctions } from "./firebaseFunctions";

const wrapper = <P, Q>(fnName: string) => {
  const fn = httpsCallable<P, Q>(firebaseFunctions, fnName);
  console.log(`Creating callable function: ${fnName}`);
  return async (request: P) => {
    console.log(`callable request: ${JSON.stringify(request, null, 2)}`);

    // // Option 2: Log the object directly without string conversion
    // console.log("callable request:", request);

    // // Option 3: Use console.dir for more detailed object inspection
    // console.dir(request, { depth: null });
    const response = await fn(request);
    console.log(`callable response: ${JSON.stringify(response, null, 2)}`);
    return response.data;
  };
};

const createOrg = wrapper<CreateOrg.Request, CreateOrg.Response>("createOrgCf");
const addMember = wrapper<AddMember.Request, AddMember.Response>("addMemberCf");
const addGroup = wrapper<AddGroup.Request, AddGroup.Response>("addGroupCf");
const checkDomainVerificationStatus = wrapper<
  CheckDomainVerificationStatus.Request,
  CheckDomainVerificationStatus.Response
>("checkDomainVerificationStatusCf");
const getMyOrg = wrapper<GetMyOrg.Request, GetMyOrg.Response>("getMyOrgCf");
const resetPassword = wrapper<ResetPassword.Request, ResetPassword.Response>("resetPasswordCf");
const emailPassword = wrapper<EmailPassword.Request, EmailPassword.Response>("emailPasswordCf");
const suspendMember = wrapper<SuspendMember.Request, SuspendMember.Response>("suspendMemberCf");
const getDkimAttributes = wrapper<DkimAttributes.Request, DkimAttributes.Response>("getDkimAttributesCf");

export const callableFunctions = {
  addMember,
  addGroup,
  createOrg,
  checkDomainVerificationStatus,
  getMyOrg,
  suspendMember,
  resetPassword,
  emailPassword,
  getDkimAttributes,
};
